import URI from 'urijs'

export default function getWhatsappTokenRedirectUrl({
  locale,
  getMessage = () => '',
  origin = window.location.origin,
  token,
  whatsappMessage,
  whatsappPhone,
}) {
  const uri = new URI(origin)
  const callbackUrl = uri.path(`/${locale}/whatsapp-token-callback/`).addSearch({ token, phone: whatsappPhone }).toString()
  const text = `${getMessage({ callbackUrl })} <${whatsappMessage}>`
  const whatsappUrl = new URI('https://wa.me/').path(whatsappPhone).addSearch({ text }).toString()
  return whatsappUrl
}
